<script>
    import MultiSelect from "vue-multiselect"
    import FormInput from '../../../components/forms/FormInput.vue'
    import DateInput from '../../../components/forms/DateInput.vue'
    import NumberInput from "./NumberInput.vue"

    export default {
        components: {
            MultiSelect,
            FormInput,
            DateInput,
            NumberInput
        },
        props: {
            suffixesData: Array,
            spouseInfo: Object
        },
        data() {
            return {
            }
        },
        methods: {
            suffixDropdownCustomLabel(option) {
                return `${option.suffix}`
            },
        }
    }
</script>


<template>
    <div class="row mb-2">
        <label>
            Spouse Info
        </label>
        <div class="col-12 col-sm-6 col-md-4 p-2 form-group">
            <FormInput 
                title="Full Name" 
                v-model='spouseInfo.name'
                :required="true" 
                :error="spouseInfo.errors.spouse_name" 
                type="text" 
                name="name" 
            />
        </div>
        <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
            <FormInput 
                title="Middle Initial" 
                v-model='spouseInfo.middleInitial'
                :required="false" 
                :error="spouseInfo.errors.spouse_middle_initials" 
                type="text" 
                name="middleInitial" 
            />
        </div>
        <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
            <label>
                Suffix
            </label>
            <MultiSelect 
                v-model="spouseInfo.suffix"
                :custom-label="suffixDropdownCustomLabel"
                :select-label="''"
                :options="suffixesData"
                track-by="id"
                placeholder="Select Suffix"
            >
            </MultiSelect>
        </div>
        <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
            <DateInput 
                title="Date of Birth" 
                v-model='spouseInfo.dob' 
                :required="true" 
                :error="spouseInfo.errors.spouse_dob" 
                :disabledDate="(date) => date >= new Date()" 
            />
        </div>
        <div class="col-12 col-sm-6 col-md-2 p-2 form-group">
            <NumberInput 
                title="SSN/ITIN"
                placeholder="SSN or ITIN"
                v-model='spouseInfo.ssn'
                :required="true" 
                :error="spouseInfo.errors.spouse_security_number"
                :maximumlength="9"
            />
        </div>
    </div>
</template>